import React, { FC } from "react"
import { StyleProp, StyleSheet, TextProps, View, ViewStyle } from "react-native"

import useTheme from "../../features/Theme/ThemeProvider"
import { Body2 } from "../Texts"

interface IProps {
  text: string
  color?: string
  style?: StyleProp<ViewStyle>
}

const TextSeparator: FC<IProps & TextProps> = ({ text, color, style }) => {
  const {
    colors: { black },
    dimensions: { spacing },
  } = useTheme()

  const viewStyle = [styles.viewStyle, { padding: spacing }, style]
  const barStyle = [
    styles.barStyle,
    {
      backgroundColor: color || black.disabled,
    },
  ]
  const textStyle = [
    {
      paddingHorizontal: spacing,
    },
    styles.textStyle,
  ]

  return (
    <View style={viewStyle}>
      <View style={barStyle} />
      <Body2 style={textStyle} color={black.highEmphasis}>
        {text}
      </Body2>
      <View style={barStyle} />
    </View>
  )
}

const styles = StyleSheet.create({
  barStyle: {
    height: 1,
    width: 82,
  },
  textStyle: {
    height: 20,
  },
  viewStyle: {
    flex: 1,
    height: 20,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },
})

export default TextSeparator
